import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// One route only — a payout opens in a drawer over the queue, deep-linked via
// `?payoutId=`, so there is no separate detail path.
export const investorPayoutsRoutes: RouteRecordRaw[] = [
  {
    path: routes.RENTAL_DISTRIBUTION_PAYOUTS,
    name: 'RENTAL_DISTRIBUTION_PAYOUTS',
    component: () => import('./InvestorPayoutsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'view_properties',
      activeMenu: 'Rental Distribution',
    },
  },
]
